/*
所有弹窗 爆彩消息
* orderRemind --订单爆彩
* */

const state = {
  orderRemind:{
    open: false,
    name: '',
    store: '',
    num: '',
    img: '',
    srcimg: ''
  }
}

const getters  = {
  orderRemind:state =>{
    return state.orderRemind
  }
}

const mutations = {
  setOrderRemind:(state,data) =>{
    state.orderRemind = data
  },
  setOrderRemindColose:(state,data) =>{
    state.orderRemind = {
      open: data,
      name: '',
      store: '',
      num: '',
      img: '',
      srcimg: ''
    }
  }
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modelState/popup.js